export default __webpack_public_path__ + "static/media/bK.369d708b.svg";